module.exports = __webpack_public_path__ + "img/flipkart_grocery.05612d5a.png";